import { plural } from '@cian/utils';

export const generateVacanciesText = (totalCount: number) =>
  `Ещё ${totalCount - 1} ${plural(totalCount - 1, ['вакансия', 'вакансии', 'вакансий'])}`;
